<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterGroup" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="groupData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true'>
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="groupId" :visible="false"></e-column>
            <e-column field="groupName" :headerText="$t('Security.group.groupName')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getGroupList"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addGroupDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <ModifyGroup ref="addGroup" formId="addForm"></ModifyGroup>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="editGroupDialog"
        v-bind:element="editDialog.element"
        v-bind:styles="editDialog.styles"
      >
        <template v-slot:dialog-content>
          <ModifyGroup ref="editGroup" formId="editForm"></ModifyGroup>
        </template>
      </CustomDialog>

      <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
        <template v-slot:dialog-content>
          <AddDialog ref='addObj'></AddDialog>
        </template>
      </CustomDialog>

    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import ModifyGroup from '../../components/security/groupManager/modifyGroup';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';


import AddDialog from '../../components/system/ConfigInEx/addDialog';
import bus from '../../components/system/bus.js';
import { EventBus } from '../../plugins/eventBus';
let fileName ="";
export default {
  name: "GroupManager",
  provide: {
    grid: [ExcelExport]
  },
  data() {
    return {
      groupData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.groupManage')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteGroup },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
        { prefixIcon: 'icon hero-icon hero-icon-export', tooltipText: this.$t('Alarm.export') ,click: this.exportGrid },
        { prefixIcon: 'icon hero-icon hero-icon-upload', tooltipText: this.$t('DataManagent.import') ,click: this.importGrid }


      ],
      keyword: '',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      screenHeight: document.body.clientHeight - 240,
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addGroupDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addGroup,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Security.group.addGroup')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'editGroupDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.editGroup,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Security.group.editGroup')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide1, buttonModel: { content: this.$t('DataManagent.import') } },
          ],
          title: this.$t('Security.uploadFile')
        },
      }
    }
  },
  components: {
    ModifyGroup,
    BasicLayout,
    CustomDialog,
    AddDialog
  },
  mounted() {
    fileName ="";
    console.log("=====fileName===",fileName);
    bus.$on('selectNeData', (neNode) => {
      checkData = neNode;
    });

     bus.$on('fileName', (neNode) => {
           console.log("=====neNode===",neNode);
       fileName = neNode;
    });
    this.getGroupList()
  },
  methods: {
    getGroupList() {
      const url = '/lte/ems/group/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
          groupName: this.keyword,
          pageNo: this.page.pageNo,
          pageSize: this.pageSettings.pageSize
        } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          let date = new Date();
          date.setTime(v.createTime);
          v.createTime = date;
        });
        That.groupData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    showAddDialog() {
      this.$refs.addGroup.init();
      this.$refs.addGroup.queryUserList();
      this.$refs.addGroupDialog.show();
    },
    showModifyDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      for (let i=0; i<record.length; i++) {
        if (record[i].groupId=='1') {
          this.$parent.showToast('warning',`${this.$t('Security.adminGroupCannotModify')}`);
          return null;
        }
      }
      this.editId = record[0].groupId;
      this.$refs.editGroup.init();
      this.$refs.editGroup.findEditGroup(this.editId);
      this.$refs.editGroupDialog.show();
    },
    addGroup() {
      let That = this;
      const url = '/lte/ems/group/add';
      if (this.$refs.addGroup.validate()) {
        let params = this.$refs.addGroup.getParams();
        this.axios.post(url, params).then(response => {
          const result = response.data;
          if(result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getGroupList();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.$refs.addGroupDialog.clear();
          That.$refs.addGroupDialog.close();
        })
      }
    },
    editGroup() {
      let That = this;
      const url = '/lte/ems/group/edit';
      if (this.$refs.editGroup.validate()) {
        let params = this.$refs.editGroup.getParams();
        this.axios.post(url, params).then(response => {
          const result = response.data;
          if (result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getGroupList();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.$refs.editGroupDialog.clear();
          That.$refs.editGroupDialog.close();
        })
      }
    },
    deleteGroup() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      for (let i=0; i<record.length; i++) {
        if (record[i].groupId=='1') {
          this.$parent.showToast('warning',`${this.$t('Security.adminGroupCannotDelete')}`);
          return null;
        }
      }
      const url = '/lte/ems/group/delete';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.groupId);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getGroupList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        // this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    filterGroup() {
      this.getGroupList();
    },
    refreshGrid() {
      this.getGroupList();
    },
    dialogHide() {
      this.$refs.addGroupDialog.clear();
      this.$refs.addGroupDialog.close();
      this.$refs.editGroupDialog.clear();
      this.$refs.editGroupDialog.close();
    },
    getCheckedData() {
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          // this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);
          return false;
        }
        return selectedRecords;
    },
  // 导入excel
    eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
        },
    dialogHide1() {
      if(fileName ==""||fileName == undefined){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
           return;
      }
      let index = fileName.lastIndexOf(".");
      let fileType = fileName.substring(index+1).toLocaleLowerCase();

      if(fileType !='xlsx'){
        this.eventEmit('warning', this.$t('Security.fileTypeError'));
        return;
      }
    
      if(this.uploadProps.status == 1){
        this.$loading.showLoadding(this.$t('Software.progressing'));
        const url = '/lte/ems/role/importAuth';
        const param = {
          fileName: fileName
        };
        this.$axios.post(url, param).then(response => {
          this.$loading.hideLoadding();
          fileName = "";
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'warn', content:this.$t('MCS.importSuccess') });
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
        this.$refs.upload.clear();
        this.$refs.upload.close();
      }else{
          this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                this.$refs.upload.clear();
                this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
      const url = '/lte/ems/user/unlock';
      const params = {
          username: record[0].username
        } ;
      this.axios.post(url, params).then(response => {
        if (response.data) {
          this.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          this.getAccountList();
        } else {
          this.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    exportGrid(){
      const rows = this.getCheckedData(true);
          // if(rows.length ===0){
          //   this.$parent.showToast('warning',  `${this.$t('Alarm.no_checked')}`);
          // }
          this.exportData(rows);
    },
    exportData(rows){
      const param = {
        "path":"/home/",
        "fileNames":"用户管理.xlsx"
      }
      //  const data = JSON.parse(param);
      axios({
        method: 'post',
        url: '/lte/ems/role/export',
        data: param,
        responseType: 'blob'
        }).then(response => {
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
        console.log("fileNames",fileNames)
        let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", regFileNames);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        })
      },
      importGrid(){
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    exportGrid1(){
        const This = this;
        const checkedData = This.getCheckedData();
        if (checkedData) {
          const exportProperties = {
            fileName: `${this.$t('Security.groupManage')}.xlsx`,
            dataSource: checkedData
          };
          This.$refs.grid.getColumns()[0].visible = false;
          This.$refs.grid.excelExport(exportProperties);
        }
    }
  }
};
</script>

<style scoped>

</style>
